import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {FilterSettings} from '@github-ui/filter-core'

import {useSavedViewScope} from '../contexts/SavedViewEndpointsContext'

export function useSavedViewFilterSettings(): FilterSettings {
  const viewScope = useSavedViewScope()

  return {
    aliasMatching: true,
    groupAndKeywordSupport: true,
    showSuggestionsOnFocus: viewScope !== 'repository' && isFeatureEnabled('filter_suggestions_on_focus'),
  }
}
